import React, { useState, useEffect } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';

export function ModuleEditorModal({ show, onHide, initialValue = {}, onSave }) {
  const [form, setForm] = useState(initialValue);

  useEffect(() => setForm(initialValue), [initialValue, show]);

  const update = (key, value) => setForm(prev => ({ ...prev, [key]: value }));

  const handleSave = () => {
    if (!form.title) {
      alert('Please enter a module title');
      return;
    }
    onSave({
      id: form.id || `module-${Date.now()}`,
      title: form.title,
      description: form.description || '',
      index: Number(form.index) ?? 0,
      unlockThreshold: Number(form.unlockThreshold) ?? 0.75,
      trackInitialContent: form.trackInitialContent !== false,
      tags: form.tags || [],
      questions: form.questions || [],
      examples: form.examples || [],
    });
  };

  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>{form?.id ? 'Edit Module' : 'New Module'}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group className="mb-3">
            <Form.Label>Module Title</Form.Label>
            <Form.Control 
              value={form.title || ''} 
              onChange={e => update('title', e.target.value)}
              placeholder="e.g., Introduction to Python, Variables, etc."
              required
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Description</Form.Label>
            <Form.Control 
              as="textarea" 
              rows={3} 
              value={form.description || ''} 
              onChange={e => update('description', e.target.value)}
              placeholder="Optional: Describe what students will learn in this module"
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Unlock Threshold</Form.Label>
            <Form.Control 
              type="number" 
              step="0.05" 
              min="0" 
              max="1"
              value={form.unlockThreshold ?? 0.75} 
              onChange={e => update('unlockThreshold', e.target.value)}
            />
            <Form.Text className="text-muted">
              Percentage (0-1) required to unlock next module. Default: 0.75 (75%)
            </Form.Text>
          </Form.Group>
          
          <Form.Group className="mb-3">
            <Form.Check
              type="checkbox"
              id="trackInitialContent"
              label="Track Initial vs Review Content"
              checked={form.trackInitialContent !== false}
              onChange={e => update('trackInitialContent', e.target.checked)}
            />
            <Form.Text className="text-muted">
              When enabled, content blocks can be configured to show on initial visits, 
              revisits, or both. This allows you to provide different learning experiences 
              based on whether students are learning the material for the first time or reviewing it.
            </Form.Text>
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>Cancel</Button>
        <Button variant="primary" onClick={handleSave}>Save Module</Button>
      </Modal.Footer>
    </Modal>
  );
}
